var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fix-tab-skeleton",style:(_vm.styleObject)},[_c('div',{staticClass:"goods-list-skeleton"},_vm._l((_vm.arr),function(item,index){return _c('div',{key:index,staticClass:"goods-list-skeleton-content"},[_c('Skeleton',{attrs:{"styleObject":{
        width: '50px',
        height: '18px',
        marginRight: '20px',
      }}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }